<template>
  <PgButtonActionsContext class="pg-page-correlate-table" :actions="actions">
    <PgTopRemind
      class="pg-page-correlate-table__remind"
      :errors="topErrors"
      :success="topSuccess"
      :successClosable="true"
      @success-close="() => updateSuccess([])"
    ></PgTopRemind>
    <div class="pg-page-correlate-table__precondition" v-if="preconditionForm">
      <span class="pg-page-correlate-table__precondition-title">请先确定先决条件：</span>
      <PgForm
        class="pg-page-correlate-table__precondition-form"
        ref="preconditionRef"
        :formItems="preconditionForm"
        :model="preconditionData"
      ></PgForm>
    </div>
    <div class="pg-page-correlate-table__search">
      <PgInput
        class="pg-page-correlate-table__search-input"
        ref="searchRef"
        clearable
        :placeholder="searchPlaceholder"
        prefixIcon="ivu-icon-icon-pg-scan1"
        v-model="seachVal"
        @enter="addData"
      />
      <Button icon="ivu-icon-icon-pg-add" size="small" type="primary" round @click="addData"
        >添加</Button
      >
      <Button
        icon="ivu-icon-icon-pg-delete"
        size="small"
        type="danger"
        round
        :disabled="topDataSelections.length === 0"
        @click="topRemove"
      >
        删除
      </Button>
    </div>
    <div class="pg-page-correlate-table__content">
      <PgTable
        class="pg-page-correlate-table__content-top"
        :style="{ height: topHeight }"
        ref="topTableRef"
        height="auto"
        isSelection
        :column="topColumn"
        :columnTableCode="topColumnTableCode"
        :columnUrl="topColumnUrl"
        :checkboxConfig="topCheckboxConfig"
        :rowShortcutNum="rowShortcutNum"
        :buttonColumnWidth="buttonColumnWidth"
        :buttonTop="topMenuLead"
        :buttonRow="rowMenuLead"
        :extendCompileData="compileData"
        currentRow="$.getValue(data, topRowConfig.keyField) === $.getValue(topCurrentRow, topRowConfig.keyField)"
        @row-change="topRowChange"
        @checkbox-change="topCheckboxChange"
        @checkbox-all="topCheckboxAll"
      ></PgTable>
      <PgTable
        class="pg-page-correlate-table__content-bottom"
        ref="bottomTableRef"
        height="auto"
        :isSelection="isSelectionBottom"
        :rowShortcutNum="rowShortcutNum"
        :buttonColumnWidth="buttonColumnWidth"
        :buttonRow="bottomRowMenuLead"
        :buttonTop="bottomMenuLead"
        :column="bottomColumn"
        :columnTableCode="bottomColumnTableCode"
        :columnUrl="bottomColumnUrl"
        :rowConfig="{ height: 50, ...bottomRowConfig }"
        :extendCompileData="compileData"
        :seachKeys="bottomSeachKeys"
        :seachPlaceholder="bottomSeachPlaceholder"
        currentRow="$.getValue(data, bottomParent) === $.getValue(topCurrentRow, topRowConfig.keyField)"
        @checkbox-change="bottomCheckboxChange"
        @checkbox-all="bottomCheckboxAll"
      >
        <template #left>
          <div v-if="showScan" class="pg-page-correlate-table__scan">
            <PgInput
              class="pg-page-correlate-table__scan-input"
              ref="scanRef"
              clearable
              :placeholder="scanPlaceholder"
              prefixIcon="ivu-icon-icon-pg-scan1"
              v-model="scanVal"
              @enter="scanEnter"
            />
          </div>
        </template>
      </PgTable>
    </div>
  </PgButtonActionsContext>
</template>

<script setup>
import { PgButtonActionsContext } from '../../button-actions-context/index'
import { useTopErrors, useBeforValueActionsProvide, useButtonPage } from '../../../hooks/index'
import { PgTopRemind } from '../../top-remind/index'
import { PgForm } from '../../form/index'
import { usePrecondition } from '../hook/use-precondition'
import { PgTable } from '../../table/index'
import { shallowRef, ref, reactive, onMounted, onDeactivated, onActivated } from 'vue'
import { Button } from 'element-ui'
import { pgMessage } from '../../message/index'
import { pgMessageBoxAsync } from '../../message-box/index'
import { http, getValueByPath } from '../../../utils/index'

const props = defineProps({
  buttonColumnWidth: {
    type: Number,
    default: 50,
  },
  rowShortcutNum: {
    type: Number,
    default: 2,
  },
  menus: Array,
  topMenuLead: {
    type: String,
    default: 'TOP',
  },
  rowMenuLead: {
    type: String,
    default: 'ROW',
  },
  beforActions: Object,
  //表单或表格字段数据变化后的回调
  afterCallback: Function,
  buttonActions: Object,
  //先进条件初始值
  preconditionDataInit: Object,
  preconditionFormItemsUrl: {
    type: String,
    default: 'rest/ezcomp/dict/form/fetch/',
  },
  preconditionFormItems: [Array, Object],
  preconditionFormItemsCode: String,
  preconditionMessage: {
    type: String,
    default: '请完善先决条件必填信息！',
  },
  searchPlaceholder: {
    type: String,
    default: '请扫描或手动输入手术套包编号',
  },
  scanPlaceholder: {
    type: String,
    default: '请先扫描能够识别商品的条码',
  },
  scanFieldKey: {
    type: String,
    default: 'goodsStore',
  },
  showScan: {
    type: Boolean,
    default: false,
  },
  // 顶部表格-code
  topColumnTableCode: String,
  // 顶部表格-列定义url
  topColumnUrl: {
    type: String,
    default: 'rest/ezcomp/dict/table/fetch/',
  },
  // 顶部表格-列定义
  topColumn: [Array, Object],
  topRowConfig: {
    type: Object,
    default: () => ({ keyField: 'order.id' }),
  },
  topCheckboxConfig: Object,
  //上表高度
  topHeight: {
    type: String,
    default: '40%',
  },
  bottomMenuLead: {
    type: String,
    default: 'BOTTOM',
  },
  bottomRowMenuLead: {
    type: String,
    default: 'BOTTOMROW',
  },
  // 底部表格-code
  bottomColumnTableCode: String,
  // 底部表格-列定义url
  bottomColumnUrl: {
    type: String,
    default: 'rest/ezcomp/dict/table/fetch/',
  },
  // 底部表格-列定义
  bottomColumn: [Array, Object],
  bottomRowConfig: {
    type: Object,
    default: () => ({ keyField: 'id' }),
  },
  bottomParent: {
    type: String,
    default: 'orderId',
  },
  bottomSeachKeys: Array,
  bottomSeachPlaceholder: String,
  url: String,
  method: {
    type: String,
    default: 'get',
  },
  getParameters: Function,
  isSelectionBottom: { type: Boolean, default: true },
})

useButtonPage(props.menus)

//先决条件
const { preconditionData, preconditionForm, preconditionRef } = usePrecondition({
  preconditionDataInit: props.preconditionDataInit,
  preconditionFormItemsUrl: props.preconditionFormItemsUrl,
  preconditionFormItems: props.preconditionFormItems,
  preconditionFormItemsCode: props.preconditionFormItemsCode,
})

//扫码查询
const searchRef = ref(null)
const seachVal = ref('')
onMounted(() => searchRef.value.focus())
const addData = async () => {
  topCurrentRow.value = null
  const validateError = preconditionForm ? await preconditionRef.value?.validate?.() : null
  if (validateError) {
    pgMessage.error('请完善先决条件必填信息！')
    return
  }
  const param = props.getParameters?.(preconditionData.value, seachVal.value)
  const [res, err] = await http[props.method](props.url, param, { errorTip: '' })
  if (res) {
    if (
      topData.value.some(
        (im) =>
          getValueByPath(im, props.topRowConfig.keyField) ===
          getValueByPath(res.data, props.topRowConfig.keyField)
      )
    ) {
      pgMessage.error('已添加该数据')
      searchRef.value.select()
      return
    }
    topData.value = [res.data, ...topData.value]
    bottomData.value = [...(res.data?.items ?? []), ...bottomData.value]
    topDataSelections.value = []
    bottomDataSelections.value = []
    topCurrentRow.value = res.data
    allLoad()
  } else {
    const { onClose } = await pgMessageBoxAsync({
      message: err?.msg ?? '失败',
    })
    onClose()
    searchRef.value.focus()
  }
  searchRef.value.select()
}

//上表
const topTableRef = ref(null)
const topData = shallowRef([])
const topDataSelections = shallowRef([])
const topCurrentRow = shallowRef(null)
const topLoad = () => topTableRef.value.loadData(topData.value)
const topRowChange = ({ row }) => {
  topCurrentRow.value = row
}
const topCheckboxChange = ({ records }) => {
  topDataSelections.value = records
  bottomDataSelections.value = bottomData.value.filter((im) =>
    topDataSelections.value.some(
      (topIm) =>
        getValueByPath(topIm, props.topRowConfig.keyField) ===
        getValueByPath(im, props.bottomParent)
    )
  )
  bottomTableRef.value.setAllCheckboxRow(false)
  bottomTableRef.value.setCheckboxRow(bottomDataSelections.value, true)
}
const topCheckboxAll = ({ records, checked }) => {
  topDataSelections.value = records
  if (checked) {
    bottomDataSelections.value = bottomData.value
    bottomTableRef.value.setAllCheckboxRow(true)
  } else {
    bottomDataSelections.value = []
    bottomTableRef.value.setAllCheckboxRow(false)
  }
}
const topRemove = () => {
  topData.value = topData.value.filter(
    (topIm) =>
      !topDataSelections.value.some(
        (im) =>
          getValueByPath(im, props.topRowConfig.keyField) ===
          getValueByPath(topIm, props.topRowConfig.keyField)
      )
  )
  bottomData.value = bottomData.value.filter(
    (bottomIm) =>
      !topDataSelections.value.some(
        (im) =>
          getValueByPath(im, props.topRowConfig.keyField) ===
          getValueByPath(bottomIm, props.bottomParent)
      )
  )
  topDataSelections.value = []
  bottomDataSelections.value = []
  allLoad()
}

//下表
const bottomTableRef = ref(null)
const bottomData = shallowRef([])
const bottomDataSelections = shallowRef([])
const bottomLoad = () => bottomTableRef.value.loadData(bottomData.value)
const bottomCheckboxChange = ({ records, row }) => {
  bottomDataSelections.value = records
  const selectParent = bottomDataSelections.value.filter(
    (im) => getValueByPath(im, props.bottomParent) === getValueByPath(row, props.bottomParent)
  )
  const allParent = bottomData.value.filter(
    (im) => getValueByPath(im, props.bottomParent) === getValueByPath(row, props.bottomParent)
  )
  const parentRow = topData.value.find(
    (im) =>
      getValueByPath(im, props.topRowConfig.keyField) === getValueByPath(row, props.bottomParent)
  )
  const isParentSelect = topDataSelections.value.find(
    (im) =>
      getValueByPath(im, props.topRowConfig.keyField) ===
      getValueByPath(parentRow, props.topRowConfig.keyField)
  )
  if (selectParent.length === allParent.length) {
    if (!isParentSelect) {
      topDataSelections.value.push(parentRow)
      topTableRef.value.setCheckboxRow([parentRow], true)
    }
  } else if (selectParent.length === 0) {
    topDataSelections.value = topDataSelections.value.filter(
      (im) =>
        getValueByPath(im, props.topRowConfig.keyField) !==
        getValueByPath(parentRow, props.topRowConfig.keyField)
    )
    topTableRef.value.setCheckboxRow([parentRow], false)
  }
}
const bottomCheckboxAll = ({ records, checked }) => {
  bottomDataSelections.value = records
  if (checked) {
    topDataSelections.value = topData.value
    topTableRef.value.setAllCheckboxRow(true)
  } else {
    topDataSelections.value = []
    topTableRef.value.setAllCheckboxRow(false)
  }
}

// 扫码自定义序列号
const scanRef = ref(null)
const scanVal = ref('')
const scanClear = () => {
  scanVal.value = ''
}
const scanEnter = () => {
  const scanRow = bottomData.value.find(
    (im) => getValueByPath(im, `${props.scanFieldKey}.epc`) === scanVal.value
  )

  if (!scanRow) {
    pgMessage.error('未匹配到自定义序列号')
    scanRef.value.select()
    return
  }

  bottomTableRef.value.setCheckboxRow([scanRow], true)
  if (
    !bottomDataSelections.value.some(
      (im) =>
        getValueByPath(im, props.bottomRowConfig.keyField) ===
        getValueByPath(scanRow, props.bottomRowConfig.keyField)
    )
  ) {
    bottomDataSelections.value = [...bottomDataSelections.value, scanRow]
    bottomCheckboxChange({ records: bottomDataSelections.value, scanRow })
  }

  scanClear()
  scanRef.value.focus()
}

const bottomRemove = () => {
  bottomData.value = bottomData.value.filter(
    (bottomIm) =>
      !bottomDataSelections.value.some(
        (im) =>
          getValueByPath(im, props.bottomRowConfig.keyField) ===
          getValueByPath(bottomIm, props.bottomRowConfig.keyField)
      )
  )
  topData.value = topData.value.filter((topIm) =>
    bottomData.value.some(
      (im) =>
        getValueByPath(im, props.bottomParent) ===
        getValueByPath(topIm, props.topRowConfig.keyField)
    )
  )
  bottomDataSelections.value = []
  topDataSelections.value = []
  allLoad()
}

const allLoad = () => {
  topLoad()
  bottomLoad()
}

const reload = () => {
  topData.value = []
  topDataSelections.value = []
  bottomData.value = []
  bottomDataSelections.value = []
  seachVal.value = ''
  searchRef.value.focus()
  allLoad()
}

const compileData = reactive({
  preconditionData,
  topData,
  topDataSelections,
  topCurrentRow,
  bottomData,
  bottomDataSelections,
  topRowConfig: props.topRowConfig,
  bottomParent: props.bottomParent,
})

//解决由于数据量大时并且滚动之后导致表格数据都被vue监听在缓存时占用空间大
onDeactivated(() => {
  topData.value = JSON.parse(JSON.stringify(topData.value))
  topTableRef.value?.clearOb?.(topData.value)
  bottomData.value = JSON.parse(JSON.stringify(bottomData.value))
  bottomTableRef.value?.clearOb?.(bottomData.value)
})
onActivated(() => {
  if (bottomDataSelections.value.length > 0) {
    bottomTableRef.value?.setCheckboxRow?.(bottomDataSelections.value, true)
  }
  if (topDataSelections.value.length > 0) {
    topTableRef.value?.setCheckboxRow?.(topDataSelections.value, true)
  }
})

const { topErrors, updateErrors, topSuccess, updateSuccess } = useTopErrors()

const actions = {
  ...props.buttonActions,
  updateErrors,
  updateSuccess,
  bottomRemove,
  reload,
  seachFocus: () => searchRef.value.focus(),
  getTableData: () => ({
    topData: topData.value,
    bottomData: bottomData.value,
    seachVal: seachVal.value,
    preconditionData: preconditionData.value,
  }),
}

// 修改字段值前的勾子
const beforActions = {
  ...props.beforActions,
}
useBeforValueActionsProvide({
  beforActions,
  formReactive: compileData,
  actions,
  afterCallback: props.afterCallback,
})

defineExpose({
  reload,
})
</script>

<style lang="scss">
@import '../style/page-correlate-table.scss';
</style>
